import { render, staticRenderFns } from "./AuthorPage.vue?vue&type=template&id=c6620f78&"
import script from "./AuthorPage.vue?vue&type=script&lang=js&"
export * from "./AuthorPage.vue?vue&type=script&lang=js&"
import style0 from "./AuthorPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports